import React from "react";
import { Flexbox } from "../Theme/GlobalStyles";
import { Text } from "../Theme/Typography";
import { globalTheme } from "../Theme/Theme";

// First + last initial, e.g. "Devansh Chauhan" -> "DC". Falls back to "—".
export const initialsFor = (firstName = "", lastName = "") => {
  const a = (firstName || "").trim()[0] || "";
  const b = (lastName || "").trim()[0] || "";
  return (a + b).toUpperCase() || "—";
};

// A circular initials badge used in place of a placeholder user photo. Looks
// cleaner/more professional than a generic avatar image across the booking and
// dashboard lists.
const InitialsAvatar = ({ firstName, lastName, size = 32, bg }) => (
  <Flexbox
    alignCenter
    justiCenter
    maxWidth="max-content"
    style={{
      width: size,
      height: size,
      minWidth: size,
      borderRadius: "50%",
      background: bg || globalTheme.colors.grey8,
      border: `1px solid ${globalTheme.colors.nuetral2}`,
      flexShrink: 0,
    }}
  >
    <Text font11 inter semiBold nuetral8 style={{ lineHeight: 1 }}>
      {initialsFor(firstName, lastName)}
    </Text>
  </Flexbox>
);

export default InitialsAvatar;
